import { Flex } from "antd";
import { FC } from "react";

import BaseButton from "@/shared/ui/BaseButton";
import { BaseModal } from "@/shared/ui/BaseModal";

interface ConfirmOrderModalProps {
    open: boolean;
    loading: boolean;
    disabled: boolean;
    onConfirm: () => void;
    onClose: () => void;
}

export const ConfirmOrderModal: FC<ConfirmOrderModalProps> = ({
    open,
    loading,
    disabled,
    onConfirm,
    onClose,
}) => {
    return (
        <BaseModal
            title="Ви впевнені?"
            description={
                "Підтвердження оформить замовлення по всім обраним магазинам."
            }
            open={open}
            onClose={onClose}
            actions={null}
        >
            <Flex vertical gap={8}>
                <BaseButton
                    bgColor="success"
                    disabled={disabled}
                    loading={loading}
                    type="primary"
                    onClick={onConfirm}
                >
                    Оформити замовлення
                </BaseButton>

                <BaseButton type="default" onClick={onClose}>
                    Повернутися назад
                </BaseButton>
            </Flex>
        </BaseModal>
    );
};
